import React, { useEffect, useState } from "react";
import axios from "axios";
import { WebApiURL } from "../../Constants/Constants";


function AdminF() {
  const [users, setUsers] = useState([]);

  // Fetch users
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${WebApiURL}Verification/Users`);
      // Exclude pending users (status = 0)
      setUsers(res.data.filter((u) => u.status !== 0));
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  const handleAction = async (email, action) => {
    try {
      await axios.put(`${WebApiURL}Verification/${action}/${email}`);
      fetchUsers();
    } catch (err) {
      console.error(`Error performing ${action} on ${email}:`, err);
    }
  };

  const handleRoleChange = async (email, newRole) => {
    try {
      await axios.put(`${WebApiURL}Verification/ChangeRole`, { email, role: newRole });
      fetchUsers();
    } catch (err) {
      console.error(`Error updating role for ${email}:`, err);
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return { text: "Active", color: "green" };
      case 2:
        return { text: "Terminated", color: "orange" };
      case 3:
        return { text: "Declined", color: "red" };
      default:
        return { text: "Pending", color: "blue" };
    }
  };

  return (
    <div className="container mt-4">
      <h2>User Management</h2>
      <table className="table table-bordered table-striped mt-3">
        <thead>
          <tr>
            <th>Selected</th>
            <th>Full Name</th>
            <th>Surname</th>
            <th>Email</th>
            <th>Type of User</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? (
            users.map((user) => {
              const { text, color } = getStatusText(user.status);

              return (
                <tr key={user.email}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{user.fullName}</td>
                  <td>{user.surname}</td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td style={{ color, fontWeight: "bold" }}>{text}</td>
                  <td>
                    {user.status === 1 && (
                      <button
                        className="btn btn-danger btn-sm me-2"
                        onClick={() => handleAction(user.email, "terminate")}
                      >
                        Terminate
                      </button>
                    )}

                    {user.status === 2 && (
                      <button
                        className="btn btn-success btn-sm me-2"
                        onClick={() => handleAction(user.email, "activate")}
                      >
                        Activate
                      </button>
                    )}

                    {user.status === 3 && (
                      <button className="btn btn-secondary btn-sm" disabled>
                        No Action
                      </button>
                    )}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="7" className="text-center">
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AdminF;
